import React, { useEffect } from "react";
import WarehouseMapComponent from "../../components/WarehouseMap";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getNomenclatorCelule } from "../../redux/api/reports.api";
import ContentCard from "../../components/misc/ContentCard";

function WarehouseMap() {
  const dispatch = useAppDispatch();

  const {
    reports: {
      cellNomenclator: {
        data: cellNomenclatorData,
        isLoading: isLoadingCellNomenclator,
      },
    },
  } = useAppSelector((state) => ({
    reports: state.reports,
  }));

  useEffect(() => {
    dispatch(getNomenclatorCelule());
  }, [dispatch]);

  return (
    <ContentCard isLoading={isLoadingCellNomenclator} fullWidth>
      <WarehouseMapComponent locations={cellNomenclatorData} />
    </ContentCard>
  );
}

export default WarehouseMap;
